import { Services } from '@/components/sections/services';

export function ServicesPage() {
  return (
    <div className="container">
      <Services />
    </div>
  );
}